import BOLayout from "@/layouts/bo"
import RouteGuard from "@/utils/route-guard"
import LazyLoadWrapper from "../lazy-load-wrapper"

const moduleTitle = "module_title.subscription";

const index = {
  path: "subscription",
  title: moduleTitle,
  sidebarProps: {
    key: "1-9",
    logoSrc: "card",
    label: moduleTitle,
    link: "/subscription",
    groupingType: "TOOLS",
    order: 9,
  },
  element: (
    <BOLayout>
      <RouteGuard mustAuthenticated>
        <LazyLoadWrapper 
          importFn={() => import("@/pages/subscription")} 
        />
      </RouteGuard>
    </BOLayout>
  )
}

export default index
